import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import { withRouter } from "react-router-dom";
import uuid from 'uuid/v1';
import moment from 'moment';
import Page from '../../components/Page/Page';
import { NewsFilter } from '../../components';
import { NetworkContext } from '../../context/NetworkContext';
import { SnackBarContext } from "../../context/SnackbarContext";

import { Header, Results } from './components';

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    maxWidth: '100%',
    padding: theme.spacing(3)
  },
  results: {
    marginTop: theme.spacing(3)
  }
}));
export const News = withRouter(props => {

  const classes = useStyles();
  const [orders, setOrders] = useState([]);
  const snackbarCtx = React.useContext(SnackBarContext);

  const [filterparams, setFilterparams] = useState({});
  const { sendNetworkRequest } = React.useContext(NetworkContext);
  const [masters, setMasters] = useState({
    commodity: []
  });


  async function fetchallnews(filtercontent = {}) {

    let bodycontent = {
      ...filterparams
    }

    debugger
    let newslist = await sendNetworkRequest('/admin/getnews', {}, bodycontent, true)
    setOrders(newslist.module)
  }


  async function deletenews(newsobj) {

    let commodities = await sendNetworkRequest('/admin/deletenews', {}, { news_id: newsobj.id, status : newsobj.status }, true)
    snackbarCtx.setSnack({
      ...snackbarCtx,
      open: true,
      type: "success",
      msg: commodities.message,
      vertical: "top",
    });
    fetchallnews()


  }
  function applyfilter(key, value) {


    setFilterparams({
      ...filterparams,
      [key]: value
    })
  }
  async function fetchmasters() {
    let commodities = await sendNetworkRequest('/admin/getparentcommodity', {}, {}, true)
    let languages = await sendNetworkRequest('/admin/getactivelanguages', {}, {}, true)
    setMasters({
      ...masters,
      languages: languages.module,
      commodity: commodities.module

    })
  }
  useEffect(() => {
    fetchallnews()
  }, [filterparams]);

  useEffect(() => {
    fetchmasters()
    fetchallnews()
  }, []);

  return (

    <Page
      className={classes.root}
      title="Commodity"
    >
      <Header />
      <NewsFilter masters={masters} onSearch={applyfilter} onFilter={applyfilter} placeholder={"Search By title"} />
      <Results
        className={classes.results}
        orders={orders} //
        onDelete={deletenews}
      />

    </Page>

  );
});

export default News;
